import type { z } from 'zod';

/**
 * Parse `raw` against the provided Zod schema. On failure, log a console
 * warning (dev only) and fall back to a type-cast of the raw response so
 * the UI keeps rendering with whatever the platform sent.
 *
 * Same soft-fail behaviour as the gen-3 cohort-detail parser — validate
 * the intended shape without crashing on platform-side null fields or
 * unenumerated variants.
 */
export const parseOrFallback = <T>(schema: z.ZodType<T>, raw: unknown, context: string): T => {
  const result = schema.safeParse(raw);
  if (result.success) {
    return result.data;
  }
  if (import.meta.env?.DEV) {
    console.warn(
      `[data-access-cohorts] zod schema mismatch in ${context} — falling back to raw response`,
      result.error.issues
    );
  }
  return raw as T;
};
